var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIspEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1956 0.617188H2.80438C1.80785 0.617188 1 1.44368 1 2.4632V13.35C1 14.3695 1.80785 15.196 2.80438 15.196H18.1956C19.1922 15.196 20 14.3695 20 13.35V2.4632C20 1.44368 19.1922 0.617188 18.1956 0.617188Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69995 1.15063L10.4967 9.38355L19.3551 1.21059",
    stroke: "#6856DB",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24573 9.38354L1.69995 14.5745",
    stroke: "#6856DB",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2968 14.5745L13.751 9.38354",
    stroke: "#6856DB",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIspEmailIcon);
export default __webpack_public_path__ + "static/media/IspEmailIcon.c62892ecd05d6211cefeb3eef4e176f4.svg";
export { ForwardRef as ReactComponent };